import React from 'react';
import { CssBaseline } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import MainPage from './MainPage';
import ScrollProgress from './components/ScrollProgress';
import TermsAndConditions from './TermsAndConditions';
import AboutUs from './AboutUs';
import AppTheme from './theme/AppTheme';
import MenuBar from './components/MenuBar';
import Footer from './components/Footer';
import PrivacyPolicy from './PrivacyPolicy';
import Careers from './Careers';

export default function AppRouter(props) {
  // References to sections
  const highlightsRef = React.useRef(null);
  const whyChooseUsRef = React.useRef(null);
  const servicesRef = React.useRef(null);
  const faqsRef = React.useRef(null);
  const contactUsRef = React.useRef(null);

  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <Router>
        <ScrollProgress />
        <ScrollManager
          highlightsRef={highlightsRef}
          servicesRef={servicesRef}
          whyChooseUsRef={whyChooseUsRef}
          faqsRef={faqsRef}
          contactUsRef={contactUsRef}
        />
      </Router>
    </AppTheme>
  );
}

function ScrollManager({ highlightsRef, servicesRef, whyChooseUsRef, faqsRef, contactUsRef }) {
  const navigate = useNavigate();
  const location = useLocation();

  // Function to scroll to a section
  const scrollToSection = (ref, shouldNavigate = true) => {
    if (location.pathname !== '/' && shouldNavigate) {
      navigate('/', { replace: false });
      setTimeout(() => {
        if (ref?.current) {
          ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100); // Delay to allow page to load
    } else {
      if (ref && ref.current) {
        ref.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <>
      <MenuBar
        scrollToSection={scrollToSection}
        highlightsRef={highlightsRef}
        servicesRef={servicesRef}
        whyChooseUsRef={whyChooseUsRef}
        faqsRef={faqsRef}
        contactUsRef={contactUsRef}
      />
      <div>
        <Routes>
          <Route
            path="/"
            element={
              <MainPage
                scrollToSection={scrollToSection}
                highlightsRef={highlightsRef}
                servicesRef={servicesRef}
                whyChooseUsRef={whyChooseUsRef}
                faqsRef={faqsRef}
                contactUsRef={contactUsRef}
              />
            }
          />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/careers" element={<Careers />} />
          {/* Add more routes as needed */}
        </Routes>
      </div>
      <div ref={contactUsRef}>
        <Footer
          scrollToSection={scrollToSection}
          highlightsRef={highlightsRef}
          servicesRef={servicesRef}
          whyChooseUsRef={whyChooseUsRef}
          faqsRef={faqsRef}
        />
      </div>
    </>
  );
}
